<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      elevate-on-scroll
      :height="$vuetify.breakpoint.mobile ? 72 : 96"
      elevation="4"
    >
      <v-container
        class="d-flex align-center py-0"
        :class="{
          'px-0': $vuetify.breakpoint.mobile,
          'px-16': $vuetify.breakpoint.xlOnly,
          'px-8': $vuetify.breakpoint.mdAndUp,
        }"
      >
        <img
          :src="'../images/company-logo.png'"
          :width="$vuetify.breakpoint.mobile ? 78 : 104"
          :height="$vuetify.breakpoint.mobile ? 72 : 96"
          class="d-block my-auto"
        />
        <v-spacer></v-spacer>
        <v-row align="center">
          <v-col
            v-if="!$vuetify.breakpoint.mobile"
            cols="12"
            md="8"
            class="d-flex align-center"
          >
            <h3 class="mx-4">
              <a class="nav" :href="$route('home')">Home</a>
            </h3>
            <h3 class="mx-4">
              <a class="nav" href="#programs">Program</a>
            </h3>
            <h3 class="mx-4">
              <a class="nav" :href="$route('contact-us')">Kontak</a>
            </h3>
            <h3 class="mx-4">
              <a class="nav" :href="$route('about-us')">Tentang</a>
            </h3>
          </v-col>
          <v-col cols="12" md="4" class="text-right">
            <v-btn
              rounded
              depressed
              outlined
              color="primary"
              class="mx-2"
              :href="registerUrl"
              target="_blank"
            >
              Daftar
            </v-btn>
            <v-btn
              rounded
              depressed
              class="mx-2"
              color="primary"
              :href="$route('login')"
            >
              <v-icon left>mdi-account</v-icon>Login
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-main>
      <alert></alert>
      <slot />
    </v-main>
    <v-footer app absolute padless color="primary white--text">
      <v-container :class="sectionClass">
        <v-row>
          <v-col v-if="!$vuetify.breakpoint.mobile" cols="12" md="auto">
            <v-img
              :src="'../images/company-logo-white.png'"
              width="104"
              height="96"
              class="mx-auto"
            />
          </v-col>
          <v-col
            cols="12"
            md="10"
            :class="{ 'text-center': $vuetify.breakpoint.mobile }"
          >
            <div class="text-h6 font-weight-bold mb-2">XuYuan Class</div>
            <div class="text-subtitle-2 mb-2">
              Apartemen Puncak Bukit Golf 3311, Bukit Darmo Boulevard No B2 RW
              01, Pradahkalikendal, Kec. Dukuh Pakis, Kota Surabaya <br />
              <div>
                <v-icon color="white" small left>mdi-whatsapp</v-icon>
                <a
                  href="https://wa.me/6281232006750"
                  class="white--text"
                  target="_blank"
                >
                  +62 812 3200 6750
                </a>
              </div>
              <div>
                <v-icon color="white" small left>mdi-instagram</v-icon>
                <a
                  href="https://www.instagram.com/xuyuanchinese"
                  class="white--text"
                  target="_blank"
                >
                  @xuyuanclass
                </a>
              </div>
              <div>
                <v-icon color="white" small left>mdi-email</v-icon>
                <a
                  href="mailto:xuyuanchinesecourse@yahoo.com"
                  class="white--text"
                  target="_blank"
                >
                  xuyuanchinesecourse@yahoo.com
                </a>
              </div>
            </div>
            <div class="text-subtitle-2">
              <span> XuYuan Class &copy; {{ new Date().getFullYear() }} </span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>
<script>
import constant from '@/constant'
export default {
  name: 'Home',
  computed: {
    registerUrl() {
      return constant.waRegisterUrl
    },
  },
}
</script>
<style lang="scss" scoped>
a.nav {
  text-decoration: none;
  color: inherit !important;
}
</style>
